export default __webpack_public_path__ + "static/telecel_play-cb3cd6feb7d97c2a59f95019bea9f4b0.webp";